import { render } from "./fileUploadHint.vue?vue&type=template&id=3d81d9d1&lang=pug"
import script from "./fileUploadHint.vue?vue&type=script&lang=js"
export * from "./fileUploadHint.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/fields/fileUploadHint.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d81d9d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d81d9d1', __exports__)) {
    api.reload('3d81d9d1', __exports__)
  }
  
  module.hot.accept("./fileUploadHint.vue?vue&type=template&id=3d81d9d1&lang=pug", () => {
    api.rerender('3d81d9d1', render)
  })

}


export default __exports__